import React from 'react';
import { Provider } from 'react-redux';
import configureStore from '../store/configure_store';

export const store = configureStore({});

class StoreWrapper extends React.PureComponent {
  render() {
    return <Provider store={this.props.store || store}>{this.props.children}</Provider>;
  }
}

export default StoreWrapper;
